import { createStore as reduxCreateStore, compose, Store } from 'redux';
import * as firebase from 'firebase';
const { reactReduxFirebase } = require('react-redux-firebase');

import rootReducer, { RootState } from './reducers/root';

// Firebase config
firebase.initializeApp({
  apiKey: 'AIzaSyAwyD4BSor_aADMDcEN6pzKdYpddGvlRfM',
  authDomain: 'briana-wedding.firebaseapp.com',
  databaseURL: 'https://briana-wedding.firebaseio.com',
  projectId: 'briana-wedding',
  storageBucket: 'briana-wedding.appspot.com',
  messagingSenderId: '923611641161',
});

export default function createStore(initialState?: Partial<RootState>): Store<RootState> {
  return reduxCreateStore<RootState>(
    rootReducer,
    initialState as RootState,
    compose(
      reactReduxFirebase(firebase, {
        userProfile: 'users',
      }),
    ),
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store.ts